const config = {
  server: {
    // url: "http://localhost:8000/api",
    url: "https://stage.thetecheye.com/api",
  },
};

export default config;
